export default __webpack_public_path__ + "img/86f5137da20c3df45757fe22ccc9dd10.svg";